if (!customElements.get('op-variant-media')) {
  customElements.define(
    'op-variant-media',
    class OpVariantMedia extends HTMLElement {
      connectedCallback() {
        this.mql = window.matchMedia('(min-width: 750px)');
        this.onBreakpointChange = this.initSplides.bind(this);
        if (this.mql.addEventListener) {
          this.mql.addEventListener('change', this.onBreakpointChange);
        } else {
          this.mql.addListener(this.onBreakpointChange);
        }
        this.initSplides();
      }

      disconnectedCallback() {
        if (!this.mql || !this.onBreakpointChange) return;
        if (this.mql.removeEventListener) {
          this.mql.removeEventListener('change', this.onBreakpointChange);
        } else {
          this.mql.removeListener(this.onBreakpointChange);
        }
        this.destroySplides();
      }

      initSplides() {
        if (typeof Splide === 'undefined') return;

        this.destroySplides();
        this.splides = [];

        const isDesktop = this.mql ? this.mql.matches : window.matchMedia('(min-width: 750px)').matches;
        const selector = isDesktop
          ? '.op-product-media__desktop [data-op-splide]'
          : '.op-product-media__mobile [data-op-splide]';

        this.querySelectorAll(selector).forEach((element) => {
          const slideCount = element.querySelectorAll('.splide__slide').length;
          const splide = new Splide(element, {
            type: slideCount > 1 ? 'loop' : 'slide',
            perPage: 1,
            arrows: slideCount > 1,
            pagination: slideCount > 1,
            rewind: true,
            speed: 400,
            gap: 0,
            drag: slideCount > 1,
            height: '100%',
          });
          splide.mount();
          this.splides.push(splide);
        });
      }

      destroySplides() {
        (this.splides || []).forEach((splide) => {
          try {
            splide.destroy();
          } catch (error) {
            // Splide may already be destroyed after a DOM swap
          }
        });
        this.splides = [];
      }
    }
  );
}
